import { Text, Heading } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { IHubContentTypeToLabelMap } from "../constants/filters";
import { discoveryFilterStore } from "../store/filters";

import { FullHeightDivFlexCenter } from "./common/styled.components";

const TextAlignCenterDiv = styled.div`
    text-align: center;
    max-width: 75vh;
`;

export const ContentUnavailable: React.FunctionComponent<{
    message: string;
}> = ({ message }) => {
    const contentType = useStore(
        discoveryFilterStore,
        (state) => state.contentType,
    );

    return (
        <FullHeightDivFlexCenter
            id="content-unavailable"
            data-testid="content-unavailable"
        >
            <Heading renderAs="h3">
                No {IHubContentTypeToLabelMap[contentType].toLowerCase()}{" "}
                returned
            </Heading>
            <TextAlignCenterDiv>
                <Text>{message}</Text>
            </TextAlignCenterDiv>
        </FullHeightDivFlexCenter>
    );
};
